import React, { Fragment, useEffect } from "react";
import NewNavbar from "../../new-components/NewNavbar";
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from "../../new-components/NewOverrides";
import NewDesignSystem from "../../new-components/NewDesignSystem";
import ModernBlogDetails from "../../components/BlogDetails/ModernBlogDetails";
import NewFooter from "../../new-components/NewFooter";
import NewMadeWith from "../../new-components/NewMadeWith";
import NewScrollTop from "../../new-components/NewScrollTop";

const BlogDetailsFull = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />

      <NewPageHeader />
      <ModernBlogDetails />
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};

export default BlogDetailsFull;
